export const SIGN_SERVER_REQUEST_START = 'SIGN_REQUEST_START';
export const SIGN_CLIENT_REQUEST_START = 'SIGN_CLIENT_REQUEST_START';
export const SIGN_REQUEST_SUCCESS = 'SIGN_REQUEST_SUCCESS';
export const SIGN_REQUEST_FAILURE = 'SIGN_REQUEST_FAILURE';
export const CLEAR_SIGN_DATA = 'CLEAR_SIGN_DATA';

export const signDocumentsOnServer = (payload) => ({ type: SIGN_SERVER_REQUEST_START, payload });
export const signDocumentsOnClient = (payload) => ({ type: SIGN_CLIENT_REQUEST_START, payload });
export const signDocumentsSuccess = () => ({ type: SIGN_REQUEST_SUCCESS });
export const signDocumentsFailure = (payload) => ({ type: SIGN_REQUEST_FAILURE, payload });
export const clearSignData = () => ({ type: CLEAR_SIGN_DATA });
